<template>
  <div id="app">
    <header class="m-site-header">
      <a class="m-site-header__logo-link" href="/">
        <img
          class="m-site-header__img"
          src="/static/images/km-logo-xs.svg"
          alt="Kanchi Matrimony"
        />
      </a>

      <nav
        id="site-nav-app"
        class="m-site-header__nav m-site-nav"
        :class="{ 'is-open': isOpen }"
      >
        <div class="m-site-nav__menu-wrapper">
          <a class="m-site-nav__link" href="/ta/register/">பதிவு செய்க</a>

          <span class="m-site-nav__hamburger-menu" @click="openMenu">
            <span class="m-site-nav__link">பார்க்க</span>
            <span class="m-site-menu-icon"></span>
          </span>

          <span
            class="m-site-nav__hamburger-close m-site-menu-icon m-site-menu-icon--close"
            @click="closeMenu"
          ></span>

          <span
            class="m-site-nav__chevron-menu m-site-nav__link"
            @click="toggleMenu"
          >
            பார்க்க
            <svg class="u-feather size-16 stroke-3">
              <use href="/static/wicons/feather-sprite.svg#chevron-down" />
            </svg>
          </span>
        </div>

        <div class="m-site-nav__dropdown-wrapper">
          <div class="m-site-nav__dropdown-menu level-1">
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{ name: 'filter-by-gender' }"
              >பெண்கள்</router-link
            >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{ name: 'filter-by-gender', params: { gender: 'male' } }"
              >ஆண்கள்</router-link
            >
            <span
              class="m-site-nav__dropdown-link m-site-nav__dropdown-link--stub"
              @click="setActiveLevel1Item('profession')"
            >
              <svg class="u-feather size-16 stroke-3">
                <use href="/static/wicons/feather-sprite.svg#chevron-left" />
              </svg>
              தொழில்
            </span>
            <span
              class="m-site-nav__dropdown-link m-site-nav__dropdown-link--stub"
              @click="setActiveLevel1Item('dosham')"
            >
              <svg class="u-feather size-16 stroke-3">
                <use href="/static/wicons/feather-sprite.svg#chevron-left" />
              </svg>
              தோஷம்
            </span>
            <span
              class="m-site-nav__dropdown-link m-site-nav__dropdown-link--stub"
              @click="setActiveLevel1Item('preference')"
            >
              <svg class="u-feather size-16 stroke-3">
                <use href="/static/wicons/feather-sprite.svg#chevron-left" />
              </svg>
              விருப்பம்
            </span>
          </div>

          <div
            class="m-site-nav__dropdown-menu level-2 profession"
            v-show="activeLevel1Item == 'profession'"
          >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{ name: 'filter-by-tag', params: { tag: 'doctor' } }"
              >மருத்துவர்</router-link
            >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{ name: 'filter-by-tag', params: { tag: 'advocate' } }"
              >வழக்கறிஞர்</router-link
            >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{ name: 'filter-by-tag', params: { tag: 'govt-job' } }"
              >அரசு பணி</router-link
            >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{ name: 'filter-by-tag', params: { tag: 'it-sector' } }"
              >ஐ. டி. துறை</router-link
            >
          </div>

          <div
            class="m-site-nav__dropdown-menu level-2 dosham"
            v-show="activeLevel1Item == 'dosham'"
          >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{ name: 'filter-by-tag', params: { tag: 'chevvai-dosham' } }"
              >செவ்வாய் தோஷம்</router-link
            >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{
                name: 'filter-by-tag',
                params: { tag: 'raahu-kethu-dosham' },
              }"
              >இராகு-கேது தோஷம்</router-link
            >
          </div>

          <div
            class="m-site-nav__dropdown-menu level-2 preference"
            v-show="activeLevel1Item == 'preference'"
          >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{ name: 'filter-by-tag', params: { tag: 'abroad' } }"
              >வெளிநாடு</router-link
            >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{ name: 'filter-by-tag', params: { tag: 'remarriage' } }"
              >மறுமணம்</router-link
            >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{ name: 'filter-by-tag', params: { tag: 'any-caste-ok' } }"
              >சாதி தடையில்லை</router-link
            >
            <router-link
              class="m-site-nav__dropdown-link"
              :to="{
                name: 'filter-by-tag',
                params: { tag: 'any-marital-status-ok' },
              }"
              >திருமணநிலை த/இ</router-link
            >
          </div>
        </div>

        <div class="m-site-nav__overlay" @click="closeMenu"></div>
      </nav>
    </header>

    <router-view />

    <section class="m-social-media">
      <nav class="m-social-media__nav">
        <a
          href="https://www.facebook.com/Kanchi-Matrimony-108598535030745"
          class="m-social-media__link"
          target="_blank"
        >
          <i class="m-social-media__icon m-social-media__icon--facebook"></i>
        </a>
        <a
          href="https://instagram.com/kanchimatri"
          class="m-social-media__link"
          target="_blank"
        >
          <i class="m-social-media__icon m-social-media__icon--instagram"></i>
        </a>
        <a
          href="https://twitter.com/kanchimatri"
          class="m-social-media__link"
          target="_blank"
        >
          <i class="m-social-media__icon m-social-media__icon--twitter"></i>
        </a>
        <a
          href="https://t.me/kanchimatri"
          class="m-social-media__link"
          target="_blank"
        >
          <i class="m-social-media__icon m-social-media__icon--telegram"></i>
        </a>
      </nav>
    </section>

    <footer class="m-site-footer">
      <div class="m-site-footer__container">
        <a
          href="/ta/register/"
          class="m-site-footer__link m-site-footer__link--register"
          >பதிவு செய்க</a
        >

        <a
          href="/ta/posts/"
          class="m-site-footer__link m-site-footer__link--blog"
          >வலைப்பதிவுகள்</a
        >

        <div
          class="m-site-footer__section m-site-footer__section--profession m-quicklinks"
        >
          <span class="m-quicklinks__title">தொழில்</span>
          <nav class="m-quicklinks__nav">
            <a href="/ta/tags/doctor/" class="m-quicklinks__link">மருத்துவர்</a>
            <a href="/ta/tags/advocate/" class="m-quicklinks__link"
              >வழக்கறிஞர்</a
            >
            <a href="/ta/tags/govt-job/" class="m-quicklinks__link">அரசு பணி</a>
            <a href="/ta/tags/it-sector/" class="m-quicklinks__link"
              >ஐ. டி. துறை</a
            >
          </nav>
        </div>

        <div
          class="m-site-footer__section m-site-footer__section--dosham m-quicklinks"
        >
          <span class="m-quicklinks__title">தோஷம்</span>
          <nav class="m-quicklinks__nav">
            <a href="/ta/tags/chevvai-dosham/" class="m-quicklinks__link"
              >செவ்வாய் தோஷம்</a
            >
            <a href="/ta/tags/raahu-kethu-dosham/" class="m-quicklinks__link"
              >இராகு-கேது தோஷம்</a
            >
          </nav>
        </div>

        <div
          class="m-site-footer__section m-site-footer__section--preference m-quicklinks"
        >
          <span class="m-quicklinks__title">விருப்பம் </span>
          <nav class="m-quicklinks__nav">
            <a href="/ta/tags/abroad/" class="m-quicklinks__link">வெளிநாடு</a>
            <a href="/ta/tags/remarriage/" class="m-quicklinks__link"
              >மறுமணம்</a
            >
            <a href="/ta/tags/any-caste-ok/" class="m-quicklinks__link"
              >சாதி தடையில்லை</a
            >
            <a href="/ta/tags/any-marital-status-ok/" class="m-quicklinks__link"
              >திருமணநிலை தடையில்லை</a
            >
          </nav>
        </div>

        <div
          class="m-site-footer__section m-site-footer__section--misc m-quicklinks"
        >
          <span class="m-quicklinks__title">மற்றவை</span>
          <nav class="m-quicklinks__nav">
            <a href="/ta/raasi-compatibility/" class="m-quicklinks__link"
              >இராசி பொருத்தம்</a
            >
            <a href="/ta/pricing/" class="m-quicklinks__link"
              >கட்டண திட்டங்கள்</a
            >
          </nav>
        </div>

        <div
          class="m-site-footer__section m-site-footer__section--address m-address"
        >
          <span class="m-address__title">முகவரி</span>
          <p>
            F2, புதிய எண் 14, பழைய எண் 114,<br />
            காமராஜர் தெரு,<br />
            பேருந்து நிலையம் எதிரில்,<br />
            காஞ்சிபுரம் - 632 501.<br />
            <br />
            <a
              class="m-address__link"
              target="_blank"
              href="https://goo.gl/maps/ZfkUiohGH64AFQJy9"
              >கூகுள் மேப்-இல் பார்க்க</a
            ><br />
            <br />
            <a class="m-address__phone u-number-font" href="tel:+916369286741"
              >6369-286741</a
            >
          </p>
        </div>

        <div class="m-site-footer__section m-site-footer__section--legal">
          <div class="m-legal">
            <nav class="m-legal__nav">
              <a class="m-legal__link" href="/ta/privacy-policy/"
                >Privacy policy</a
              >
              <a class="m-legal__link" href="/ta/terms-conditions/"
                >Terms &amp; Conditions</a
              >
              <a class="m-legal__link" href="/ta/refund-policy/"
                >Refund policy</a
              >
              <a class="m-legal__link" href="/ta/about-us/">About us</a>
            </nav>
          </div>

          <p class="m-site-footer__copyrights">
            Copyrights &copy; 2021-{{ currentYear() }} Webinative Technologies.
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<style lang="scss">
@import "src/scss/style.scss";
</style>

<script>
import moment from "moment";
export default {
  name: "App",
  data() {
    return {
      isOpen: false,
      activeLevel1Item: null,
    };
  },
  methods: {
    toggleMenu() {
      this.activeLevel1Item = null;
      this.isOpen = !this.isOpen;
    },
    openMenu() {
      this.isOpen = true;
    },
    closeMenu() {
      this.activeLevel1Item = null;
      this.isOpen = false;
    },
    setActiveLevel1Item(item) {
      const allowedValues = ["profession", "dosham", "preference"];

      if (allowedValues.indexOf(item) < 0) {
        return;
      }

      this.activeLevel1Item = item;
    },
    currentYear() {
      return moment().year();
    },
  },
  watch: {
    $route: function () {
      this.closeMenu();
    },
  },
};
</script>
